import * as React from 'react';
import { State } from '~/Reducers';
import { useDispatch, useSelector } from 'react-redux';
import equal from 'fast-deep-equal/react';
import { AUCTION_KIND, CATEGORIES, DWH_EVENTS } from '~/const';
import GuideDecorator from '~/decorators/GuideDecorator/GuideDecorator';
import { GUIDE_NAMES, PLACEMENT } from '~/components/WelcomePage/steps';
import HelperIcon from '~/components/HelperIcon/HelperIcon';
import styles from '~/components/TopPanel/TopPanel.scss';
import { ICurrentPage } from '~/Actions/ActionAppType';
import dwhExport from '~/api/dwhExport';
import { changeVisiblePopup } from '~/Actions/ActionApp';
import { POPUPS_NAME } from '../PopupManager';
import { t } from '~/utils/localization';
import { CategoryLabelAboutTypes } from '~/types/category';
import store from '~/Store';
import DefaultTooltip from '../Tooltip/DefaultTooltip';
import { openUrl } from '~/utils/settings';
import { playButtonClickSound } from '~/api/WoWsClient';

interface IGuideWrapperState {
    activeAuctions: IAuction[];
    currentPage: ICurrentPage;
    menu: IMenuMap;
    categories: ICategories;
}

const stateSelector = (state: State): IGuideWrapperState => {
    return {
        currentPage: state.ReducerApp.currentPage,
        activeAuctions: state.ReducerAuction.activeAuctions,
        menu: state.ReducerApp.menu,
        categories: state.ReducerApp.categories,
    };
};

const GuideWrapper = () => {
    const dispatch = useDispatch();
    const state = useSelector<State, IGuideWrapperState>(stateSelector, equal);
    const currentPage = state.currentPage;
    const currentCategoryConfig = state.categories[currentPage?.name];

    if (!currentCategoryConfig?.label) {
        return null;
    }

    const auctions = state.activeAuctions;
    const auctionsKind = Array.from(new Set(auctions.map((a) => a.kind))).join(', ');

    if (currentPage.name === CATEGORIES.AUCTION && auctionsKind.includes(AUCTION_KIND.SECOND_PRICE)) {
        const onClick = () => {
            dwhExport.send(DWH_EVENTS.OPEN_RULES);
            dispatch(changeVisiblePopup(POPUPS_NAME.AUCTION_ABOUT_POPUP, true));
        };
        return (
            <HelperIcon
                label={currentCategoryConfig.label.title || t('Правила')}
                onClick={onClick}
                className={styles.helperIcon}
                tooltipBody={currentCategoryConfig.label.tooltipText && <DefaultTooltip text={currentCategoryConfig.label.tooltipText} />}
            />
        );
    }

    const onClick = () => {
        switch (currentCategoryConfig.label.type) {
            case CategoryLabelAboutTypes.IFRAME:
                store.dispatch(changeVisiblePopup(POPUPS_NAME.IFRAME_POPUP, true, { iframeUrl: currentCategoryConfig.label.value }));
                break;

            case CategoryLabelAboutTypes.POPUP:
                if (Object.values(POPUPS_NAME).includes(currentCategoryConfig.label.value)) {
                    const popupName = currentCategoryConfig.label.value?.toUpperCase() as keyof typeof POPUPS_NAME;
                    store.dispatch(changeVisiblePopup(POPUPS_NAME[popupName], true));
                }
                break;

            case CategoryLabelAboutTypes.LINK:
                openUrl(currentCategoryConfig.label.value);
                break;
        }
    };

    return (
        <GuideDecorator names={[GUIDE_NAMES.guide_rules_of_category]} placement={PLACEMENT.CENTER} className={styles.guideWrapper}>
            <HelperIcon
                label={currentCategoryConfig.label.title || t('О cобытии')}
                onClick={onClick}
                className={styles.helperIcon}
                tooltipBody={<DefaultTooltip text={currentCategoryConfig.label.tooltipText ?? t('Читайте подробности о текущих предложениях и другую полезную информацию')} />}
            />
        </GuideDecorator>
    );
};

export default GuideWrapper;
